<template>
  <transition name="slide">
    <div v-show="shouldShowJiji" class="jiji-area" @click="onClick">
      <p class="jiji"><span class="jiji-face">👨‍🦳</span> {{ text }}</p>
    </div>
  </transition>
</template>

<script setup lang="ts">
interface Props {
  shouldShow: boolean;
  text: string;
}

const props = defineProps<Props>();

const jijiCount = ref<number>(0);

const onClick = () => {
  jijiCount.value = jijiCount.value + 1;
};

const shouldShowJiji = computed<boolean>(() => props.shouldShow && jijiCount.value === 0);
</script>

<style lang="scss" scoped>
.jiji-area {
  cursor: pointer;
}

.jiji {
  background-color: #111;
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  padding: 4px 8px;
  font-size: 12px;
  width: fit-content;

  &:hover {
    -webkit-animation: fluffy 0.8s linear 0s 1;
    animation: rumble 0.12s linear infinite;
  }
}

.slide-enter-active,
.slide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3s cubic-bezier(0, 0, 0.2, 1) 3ms;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(200px) translateY(0px);
}

@keyframes rumble {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }
  12.5% {
    transform: rotate(0.8deg) translate(1px, -1px);
  }
  25% {
    transform: rotate(0.8deg) translate(0px, 1px);
  }
  37.5% {
    transform: rotate(0.8deg) translate(-1px, 0);
  }
  50% {
    transform: rotate(0deg) translate(0, 0);
  }
  62.5% {
    transform: rotate(-0.8deg) translate(1px, 0);
  }
  75% {
    transform: rotate(-0.8deg) translate(0, 1px);
  }
  87.5% {
    transform: rotate(-0.8deg) translate(-1px, -1px);
  }
  100% {
    transform: rotate(0deg) translate(0, 0);
  }
}
</style>
